/* CUSTOM_ROOM_DESIGNER_BY_CLAUDE — "See In Your Space" badge trace animation.

   Lifted out of snippets/product-label.liquid 2026-08-23. It used to be an inline
   <script> inside the product-labels block, which is tagged
   data-dynamic-variant-content -- so every swatch click replaced it. The
   replacement HTML is built by DOMParser, and script nodes adopted out of a
   DOMParser document never execute. Measured on the 3103-L: 5 running animations
   before the first swatch click, 0 after, and it never came back until reload.
   The badge still rendered and the link still worked; it just stopped animating.

   So the animation is bound here instead, and re-bound on the theme's own
   on:variant:change event (dispatched by variant-picker.js announceChange, after
   updateContent has already swapped the new markup in). setup() is idempotent --
   a badge it has already wired carries data-rd-trace-bound and is skipped, so
   repeated events cannot stack duplicate infinite animations on one element. */
(function () {
  var DUR = 4800;
  var TIMING = { duration: DUR, delay: 500, iterations: Infinity };

  function setup() {
    var rd = document.querySelector('.product-info__block .product-label-wrapper--room-designer');
    if (!rd) return;
    var badge = rd.querySelector('.product-label--room-designer');
    if (!badge || badge.dataset.rdTraceBound === 'true') return;

    var svg = badge.querySelector('.rd-trace-svg');
    var path = badge.querySelector('.rd-trace-path');
    var circle = badge.querySelector('.rd-trace-circle');
    var reveal = badge.querySelector('.rd-trace-reveal');
    var ripple = badge.querySelector('.rd-trace-ripple');
    if (!svg || !path || !circle || !reveal || !ripple) return;

    badge.dataset.rdTraceBound = 'true';

    /* Defer a frame so offsetWidth/offsetHeight are the laid-out values. */
    requestAnimationFrame(function () {
      var bw = badge.offsetWidth + 2;
      var bh = badge.offsetHeight + 2;
      var perim = 2 * (bw + bh);
      var d = 'M1,1 L' + (bw - 1) + ',1 L' + (bw - 1) + ',' + (bh - 1) + ' L1,' + (bh - 1) + ' Z';

      var pad = 6;
      svg.setAttribute('viewBox', (-pad) + ' ' + (-pad) + ' ' + (bw + pad * 2) + ' ' + (bh + pad * 2));
      path.setAttribute('d', d);
      circle.style.offsetPath = "path('" + d + "')";

      /* Reveal mask: solid stroke that draws progressively, clips the dashed path */
      reveal.setAttribute('d', d);
      reveal.style.strokeDasharray = perim;
      reveal.style.strokeDashoffset = perim;

      /* Initial hidden state */
      circle.style.offsetDistance = '0%';
      circle.style.opacity = '0';
      path.style.opacity = '0';

      /* Reveal mask: solid stroke draws from perim→0 (reveals dashes behind dot) */
      reveal.animate([
        { strokeDashoffset: perim, offset: 0 },
        { strokeDashoffset: perim, offset: 0.03 },
        { strokeDashoffset: perim, offset: 0.04 },
        { strokeDashoffset: 0, offset: 0.67 },
        { strokeDashoffset: 0, offset: 0.85 },
        { strokeDashoffset: perim, offset: 0.851 },
        { strokeDashoffset: perim, offset: 1 }
      ], TIMING);

      /* Dashed path: just fades in/out, mask handles the progressive reveal */
      path.animate([
        { opacity: 0, offset: 0 },
        { opacity: 0, offset: 0.03 },
        { opacity: 1, offset: 0.04 },
        { opacity: 1, offset: 0.71 },
        { opacity: 0, offset: 0.85 },
        { opacity: 0, offset: 1 }
      ], TIMING);

      /* Dot rides the same path via offset-distance — perfectly in sync */
      circle.animate([
        { offsetDistance: '0%', opacity: 0, offset: 0 },
        { offsetDistance: '0%', opacity: 0, offset: 0.03 },
        { offsetDistance: '0%', opacity: 1, offset: 0.04 },
        { offsetDistance: '100%', opacity: 1, offset: 0.67 },
        { offsetDistance: '100%', opacity: 0, offset: 0.70 },
        { offsetDistance: '100%', opacity: 0, offset: 1 }
      ], TIMING);

      /* Ripple burst when trace completes the loop (at start/end point) */
      ripple.setAttribute('cx', '1');
      ripple.setAttribute('cy', '1');
      ripple.animate([
        { transform: 'translate(0px, 0px) scale(1)', opacity: 0, offset: 0 },
        { transform: 'translate(0px, 0px) scale(1)', opacity: 0, offset: 0.665 },
        { transform: 'translate(0px, 0px) scale(1)', opacity: 0.7, offset: 0.67 },
        { transform: 'translate(0px, 0px) scale(5)', opacity: 0, offset: 0.76 },
        { transform: 'translate(0px, 0px) scale(5)', opacity: 0, offset: 1 }
      ], TIMING);

      /* Background flash on completion */
      badge.animate([
        { backgroundColor: '#000F1C', offset: 0 },
        { backgroundColor: '#000F1C', offset: 0.66 },
        { backgroundColor: '#1a2a3d', offset: 0.69 },
        { backgroundColor: '#000F1C', offset: 0.74 },
        { backgroundColor: '#000F1C', offset: 1 }
      ], TIMING);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  /* The swatch swap replaces the badge with fresh markup carrying no bound flag,
     so this re-arms it. Fires after updateContent, so the new node is in place. */
  document.addEventListener('on:variant:change', setup);
})();
